export class SvgHelper {

    public static createPath(points: [number, number][]): string {
        return 'M' + points.map(([x, y]) => `${Math.round(x)} ${Math.round(y)}`).join(' L') + 'Z';
    }

    public static calculateDelta(height: number, multiplier: number): number {
        return 100 - multiplier * height;
    }

    public static generateType1ShadowPath(d: number, points: number[]): string {
        return SvgHelper.createPath([
        [points[0] - d, points[1] - d],
        [points[2], points[3]],
        [points[4] + d / 2, d >= 10 ? points[5] : points[5] - 10],
        [points[6], points[7] + d],
        [points[8] - 2 * d, points[9]],
        ]);
    }


    public static generateType2ShadowPath(d: number, points: number[]): string {
        return this.createPath([
        [points[0] - d, points[1] - d],
        [points[2] + d, points[3] - d],
        [points[4] + d, points[5] + d],
        [points[6] + d, points[7] + d],
        [points[8] - d, points[9] + d],
        [points[10] - d, points[11] + d],
        [points[12] - 2.5 * d, points[13]],
        ]);
    }


    public static generateType3ShadowPath(d: number, points: number[]): string {
        return this.createPath([
        [points[0], points[1]],
        [points[2], points[3]],
        [points[4], points[5] + d],
        [points[6] - d, points[7]],
        [points[8] - d, points[9]],
        [points[10] + d, points[11]],
        ]);
    }
}